import { jsx as _jsx } from "react/jsx-runtime";
import { useConfig } from "../../providers/useConfig";
import styles from "./TextWordBreakWrapper.module.scss";
export const getWordBreakClassName = (wordBreak = "default") => {
    if (wordBreak === "default") {
        return "defaultWrapText";
    }
    return "asianWrapText";
};
export const TextWordBreakWrapper = ({ children, className }) => {
    const { wordBreak } = useConfig();
    const textWordBreakClassName = getWordBreakClassName(wordBreak);
    return _jsx("div", { className: `${className} ${styles[textWordBreakClassName]}`, children: children });
};
//# sourceMappingURL=TextWordBreakWrapper.js.map